/* rk-pdp.js — JS compartido de la familia de secciones rk-pdp-* (PDPs migradas de GemPages).
   Cargado con <script defer> desde cada sección que lo necesita; todo va con guardas
   customElements.get() porque el tag puede aparecer varias veces en la misma página. */

/* Add-to-cart por AJAX (/cart/add.js) + apertura del drawer UpCart (regla del SOP:
   UpCart detecta el add y abre; los eventos y el fallback a /cart cubren el resto). */
if (!customElements.get('rk-atc')) {
  class RkAtc extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.btn = this.querySelector('button[type="submit"]');
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.#add();
      });
      // stepper de cantidad (−/+)
      const qty = this.querySelector('[name="quantity"]');
      for (const stepBtn of this.querySelectorAll('[data-rk-qty]')) {
        stepBtn.addEventListener('click', () => {
          const delta = parseInt(stepBtn.dataset.rkQty, 10);
          const actual = parseInt(qty?.value || '1', 10) || 1;
          if (qty) qty.value = Math.max(1, actual + delta);
        });
      }
      qty?.addEventListener('change', () => {
        const n = parseInt(qty.value, 10);
        if (!n || n < 1) qty.value = 1;
      });
    }

    async #add() {
      const idInput = this.form.querySelector('[name="id"]');
      const qtyInput = this.form.querySelector('[name="quantity"]');
      const id = parseInt(idInput?.value || '0', 10);
      const quantity = parseInt(qtyInput?.value || '1', 10) || 1;
      if (!id) return;
      if (this.btn) this.btn.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }] })
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        await this.#afterAdd();
      } catch (error) {
        if (!window.RkCart) { if (window.__rkCartEarly && window.__rkCartEarly.hold) window.__rkCartEarly.hold(); else window.location.href = '/cart'; }
      } finally {
        if (this.btn) this.btn.disabled = false;
      }
    }

    async #afterAdd() {
      try {
        const cart = await (await fetch('/cart.js')).json();
        for (const el of document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]')) {
          el.textContent = cart.item_count;
        }
      } catch (error) { /* el contador lo refresca UpCart igual */ }
      for (const ev of ['cart:refresh', 'upcart:refresh', 'upcart:open']) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      }
      setTimeout(() => {
        if (!window.RkCart) {
          window.location.href = '/cart';
        }
      }, 1200);
    }
  }
  customElements.define('rk-atc', RkAtc);
}

/* Galería del buybox: track principal con scroll-snap + tira de thumbs sincronizada.
   Las flechas de los extremos se ocultan en el borde (comportamiento del original). */
if (!customElements.get('rk-gallery')) {
  class RkGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rk-track]');
      this.thumbTrack = this.querySelector('[data-rk-thumbs]');
      this.thumbs = [...this.querySelectorAll('[data-rk-thumb]')];
      this.navBtns = [...this.querySelectorAll('[data-rk-nav]')];
      this.loop = this.hasAttribute('data-thumbs-loop');
      this._loopIdx = 0;
      for (const btn of this.navBtns) {
        btn.addEventListener('click', () => {
          const dir = btn.dataset.rkNav === 'next' ? 1 : -1;
          this.#nav(dir, btn.dataset.rkFor);
        });
      }
      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => this.#goTo(i));
      });
      this.track?.addEventListener('scroll', () => {
        clearTimeout(this._debounce);
        this._debounce = setTimeout(() => this.#sync(), 90);
      }, { passive: true });
      this.thumbTrack?.addEventListener('scroll', () => {
        clearTimeout(this._debounceT);
        this._debounceT = setTimeout(() => this.#sync(), 90);
      }, { passive: true });
      this.#sync();
    }

    #index() {
      return Math.round(this.track.scrollLeft / this.track.clientWidth);
    }

    #thumbStep() {
      const a = this.thumbs[0], b = this.thumbs[1];
      if (a && b) return Math.abs(b.getBoundingClientRect().left - a.getBoundingClientRect().left);
      return a ? a.getBoundingClientRect().width + 5 : 70;
    }

    #revealThumb(i) {
      const th = this.thumbs[i];
      if (!th || !this.thumbTrack) return;
      const off = th.offsetLeft - (this.thumbTrack.clientWidth - th.offsetWidth) / 2;
      this.thumbTrack.scrollTo({ left: off, behavior: 'smooth' });
    }

    #goTo(i) {
      const max = this.thumbs.length - 1;
      const target = Math.min(Math.max(i, 0), max);
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
      if (this.loop) {
        this._loopIdx = target;
        this.#loopReveal(target);
      } else {
        this.#revealThumb(target);
      }
    }

    #nav(dir, target) {
      if (target === 'thumbs' && this.thumbTrack) {
        if (this.loop) { this.#loopStep(dir); return; }
        // avanzar de a UNA miniatura (no toda la tira)
        if (this.hasAttribute('data-arrows-always')) {
          // calco GP (tira circular): en los extremos, el click envuelve al otro lado
          const t = this.thumbTrack;
          const max = t.scrollWidth - t.clientWidth;
          if (dir > 0 && t.scrollLeft >= max - 4) { t.scrollTo({ left: 0, behavior: 'smooth' }); return; }
          if (dir < 0 && t.scrollLeft <= 4) { t.scrollTo({ left: max, behavior: 'smooth' }); return; }
        }
        this.thumbTrack.scrollBy({ left: dir * this.#thumbStep(), behavior: 'smooth' });
        return;
      }
      this.#goTo(this.#index() + dir);
    }

    /* ===== modo tira circular (data-thumbs-loop · jewelry-engraving-kit 17-sep-2026) =====
       Calco del GP-CAROUSEL con loop de las miniaturas: flechas siempre visibles, cada click
       rota UNA miniatura (en el extremo reubica la del otro lado sin salto visual) y, al cambiar
       la foto grande, la miniatura activa queda primera. Sin el atributo no cambia nada. */
    #domStep() {
      const kids = this.thumbTrack.children;
      if (kids.length > 1) return Math.abs(kids[1].getBoundingClientRect().left - kids[0].getBoundingClientRect().left);
      return kids[0] ? kids[0].getBoundingClientRect().width + 5 : 70;
    }

    #loopBusy() {
      if (this._loopLock) return true;
      this._loopLock = true;
      setTimeout(() => { this._loopLock = false; }, 350);
      return false;
    }

    #loopStep(dir) {
      const t = this.thumbTrack;
      if (!t || t.children.length < 2 || this.#loopBusy()) return;
      const step = this.#domStep();
      const max = t.scrollWidth - t.clientWidth;
      if (dir > 0 && t.scrollLeft + step > max + 1) {
        t.append(t.firstElementChild);
        t.scrollLeft = t.scrollLeft - step;
      } else if (dir < 0 && t.scrollLeft - step < -1) {
        t.prepend(t.lastElementChild);
        t.scrollLeft = t.scrollLeft + step;
      }
      t.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    #loopReveal(i) {
      const t = this.thumbTrack;
      const th = this.thumbs[i];
      if (!t || !th) return;
      const step = this.#domStep();
      let pos = [...t.children].indexOf(th);
      const maxPos = Math.max(0, Math.round((t.scrollWidth - t.clientWidth) / step));
      if (pos > maxPos) {
        const k = pos - maxPos;
        for (let j = 0; j < k; j++) t.append(t.firstElementChild);
        t.scrollLeft = Math.max(0, t.scrollLeft - k * step);
        pos = maxPos;
      }
      t.scrollTo({ left: pos * step, behavior: 'smooth' });
    }

    #sync() {
      const i = this.#index();
      if (this.loop && i !== this._loopIdx) {
        this._loopIdx = i;
        this.#loopReveal(i);
      }
      this.thumbs.forEach((thumb, j) => thumb.classList.toggle('is-active', i === j));
      for (const btn of this.navBtns) {
        let hidden = false;
        if (btn.dataset.rkFor === 'thumbs' && this.thumbTrack) {
          if (this.loop || this.hasAttribute('data-arrows-always')) { btn.classList.remove('is-hidden'); continue; }
          const atStart = this.thumbTrack.scrollLeft < 4;
          const atEnd = this.thumbTrack.scrollLeft > this.thumbTrack.scrollWidth - this.thumbTrack.clientWidth - 4;
          hidden = btn.dataset.rkNav === 'next' ? atEnd : atStart;
        } else {
          hidden = btn.dataset.rkNav === 'next' ? i >= this.thumbs.length - 1 : i <= 0;
        }
        btn.classList.toggle('is-hidden', hidden);
      }
    }
  }
  customElements.define('rk-gallery', RkGallery);
}

/* Acordeón FAQ: <details> nativo + animación de apertura/cierre como la del original. */
if (!customElements.get('rk-accordion')) {
  class RkAccordion extends HTMLElement {
    connectedCallback() {
      for (const details of this.querySelectorAll('details')) {
        const summary = details.querySelector('summary');
        const content = details.querySelector('[data-rk-panel]');
        if (!summary || !content) continue;
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          /* aditivo jewelry-engraving-kit (30-sep-2026): con data-single, GemPages ignora el click durante los
             primeros ~250ms de una apertura/cierre (medido en el original: a 80 y 200ms NO toma el segundo click;
             de 250ms en adelante sí lo toma y cierra el anterior). Sin data-single: comportamiento previo intacto. */
          if (this.hasAttribute('data-single')) {
            const lock = parseFloat(getComputedStyle(this).getPropertyValue('--rk-pb-faq-lock')) || 250;
            const ahora = performance.now();
            if (this.dataset.rkLock && ahora - Number(this.dataset.rkLock) < lock) return;
            this.dataset.rkLock = ahora;
          }
          this.#toggle(details, content);
        });
      }
    }

    /* aditivo stencils-mandala (17-sep-2026): duración/curva de la animación por vars CSS del contenedor
       (--rk-pb-faq-dur en ms, --rk-pb-faq-ease). Sin vars = 250ms ease (comportamiento previo). */
    #timing() {
      const cs = getComputedStyle(this);
      const duration = parseFloat(cs.getPropertyValue('--rk-pb-faq-dur'));
      const easing = cs.getPropertyValue('--rk-pb-faq-ease').trim();
      return { duration: duration > 0 ? duration : 250, easing: easing || 'ease' };
    }

    #toggle(details, content) {
      if (details.dataset.animating) return;
      details.dataset.animating = '1';
      if (details.open) {
        const anim = content.animate(
          [{ blockSize: `${content.scrollHeight}px` }, { blockSize: '0px' }],
          this.#timing()
        );
        anim.onfinish = () => {
          details.open = false;
          delete details.dataset.animating;
        };
      } else {
        /* aditivo mirror-kit (17-sep-2026): data-single = un solo ítem abierto a la vez (GemPages expandedMode single):
           al abrir uno se cierran los demás con la misma animación. Sin atributo = comportamiento previo. */
        if (this.hasAttribute('data-single')) {
          for (const other of this.querySelectorAll('details[open]')) {
            const oc = other.querySelector('[data-rk-panel]');
            if (other === details || !oc) continue;
            /* jewelry-engraving-kit (30-sep-2026): si ese ítem todavía se está animando, se cancela su animación y se
               cierra desde el alto ACTUAL. Antes se lo salteaba y con dos clicks seguidos quedaban los dos abiertos. */
            const desde = other.dataset.animating ? oc.getBoundingClientRect().height : oc.scrollHeight;
            if (other.dataset.animating && oc.getAnimations) { for (const anim of oc.getAnimations()) anim.cancel(); }
            other.dataset.animating = '1';
            const oa = oc.animate([{ blockSize: `${desde}px` }, { blockSize: '0px' }], this.#timing());
            oa.onfinish = () => { other.open = false; delete other.dataset.animating; };
          }
        }
        details.open = true;
        const anim = content.animate(
          [{ blockSize: '0px' }, { blockSize: `${content.scrollHeight}px` }],
          this.#timing()
        );
        anim.onfinish = () => {
          delete details.dataset.animating;
        };
      }
    }
  }
  customElements.define('rk-accordion', RkAccordion);
}

/* Stepper de cantidad (leather-glasses-case): botones ± + input propio; sincroniza el
   input[name="quantity"] del form rk-atc de la MISMA sección (.rk-pb). Aditivo 17-sep-2026. */
if (!customElements.get('rk-qty')) {
  class RkQty extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      for (const btn of this.querySelectorAll('[data-rk-qty]')) {
        btn.addEventListener('click', () => {
          const delta = btn.dataset.rkQty === 'inc' ? 1 : -1;
          this.#set((parseInt(this.input.value, 10) || 1) + delta);
        });
      }
      this.input?.addEventListener('change', () => this.#set(parseInt(this.input.value, 10) || 1));
    }

    #set(value) {
      const qty = Math.max(1, value);
      this.input.value = qty;
      const form = this.closest('.rk-pb')?.querySelector('.rk-pb__atc form input[name="quantity"]');
      if (form) form.value = qty;
      /* aditivos wood-carving-bits (17-sep-2026): con data-rk-qty-sync="page" la cantidad viaja, como en
         GemPages, a TODOS los forms rk-atc de la MISMA variante (CTA suelto, barra sticky). Sin atributo = previo. */
      if (this.dataset.rkQtySync === 'page') {
        const vid = this.closest('.rk-pb')?.querySelector('.rk-pb__atc form input[name="id"]')?.value;
        if (vid) {
          for (const f of document.querySelectorAll('rk-atc form')) {
            const q = f.querySelector('input[name="quantity"]');
            if (q && f.querySelector('input[name="id"]')?.value === vid) q.value = qty;
          }
        }
      }
    }
  }
  customElements.define('rk-qty', RkQty);
}
